import { FORM_ERROR } from 'final-form'
import React from 'react'

import { WbacService } from '@cinch/oxd-utils/requests/src'
import * as Storage from '@cinch/oxd-utils/storage/src'

import SEO from '../../../../../apps/www/src/components/seo'
import JourneyBuilder from '../../components/journey/journey.component'
import WbacWrapper from '../../components/wrapper/wrapper.component'
import { BookResponse, PersonalInformationResponse } from '../../types'

// presumed journey form values
interface PersonalFormData {
  CustomerName: string
  TelephoneNumber: string
  EmailAddress: string
}

const AppointmentVerifyComponent: React.FC<any> = ({ location, navigate }) => {
  if (
    !location.state ||
    !location.state.vehicleInformation ||
    !location.state.personalInformation ||
    !location.state.appointmentParams
  ) {
    setTimeout(() => navigate('/sell'))

    return null
  }

  const personalInformation: PersonalInformationResponse = location.state.personalInformation
  const appointmentParams: { date: string; slotId: number } = location.state.appointmentParams

  const bookAppointment = (formData: PersonalFormData) => {
    const isLegacyGuid = personalInformation.valuationCount === 1

    const data: any = {
      ValuationId: personalInformation.valuationId,
      ValuationGuid: personalInformation.valuationGuid,
      ValuationCount: personalInformation.valuationCount,
      QuoteId: personalInformation.quoteId,
      QuoteGuid: personalInformation.quoteGuid,
      Vrm: personalInformation.vrm,
      GuideBookId: personalInformation.guideBookId,
      AppointmentDate: appointmentParams.date,
      AppointmentSlotIds: [appointmentParams.slotId],
      CustomerName: formData.CustomerName,
      CustomerTelephone: formData.TelephoneNumber,
      CustomerEmailAddress: formData.EmailAddress,
      CustomerPostcode: personalInformation.customerPostcode,
      ValuationAmount: personalInformation.vehiclePriceOffered,
      VehicleCategory: personalInformation.vehicleCategory,
      LegacyGuid: personalInformation[isLegacyGuid ? 'quoteGuid' : 'valuationGuid'],
    }

    const { token: storageToken } = Storage.get(Storage.StorageKeys.wbac)

    return new Promise((resolve) => {
      WbacService.post<BookResponse>('/appointments/book/', data, {
        headers: { Authorization: `JWT ${storageToken}` },
      })
        .then(({ data: appointment }) => {
          if (appointment.vrmAlreadyHasAppointment) {
            // todo: (ek) translate
            return resolve({ [FORM_ERROR]: 'This car already has an appointment booked!' })
          }

          if (appointment.validationErrors.length) {
            return resolve({ [FORM_ERROR]: appointment.validationErrors[0] })
          }

          navigate('/sell/appointment/booked', { state: { appointment, personalInformation } })
        })
        .catch((e) => resolve({ [FORM_ERROR]: e.message }))
    })
  }

  return (
    <>
      <SEO noIndex={true} />
      <WbacWrapper>
        <JourneyBuilder
          onSubmit={bookAppointment as any}
          journey={personalInformation.journey}
          submitText={'Confirm and book'}
        />
      </WbacWrapper>
    </>
  )
}

export default AppointmentVerifyComponent
